import { useCallback } from 'react';
import { useAssessmentsQuestions } from 'features/assessments/hooks/useAssessmentsQuestions';
import { useAssessmentsLoadAnswers } from 'features/assessments/hooks/useAssessmentsLoadAnswers';

export const useLoadAssessmentRetry = () => {
  const { error: assessmentsQuestionsError, refetchQuestions } = useAssessmentsQuestions();
  const { assessmentsAnswersError, refetchAssessmentsAnswers } = useAssessmentsLoadAnswers();

  const retryLoadAssessments = useCallback(() => {
    if (assessmentsQuestionsError) {
      refetchQuestions();
    }
    if (assessmentsAnswersError) {
      refetchAssessmentsAnswers();
    }
  }, [
    refetchQuestions,
    refetchAssessmentsAnswers,
    assessmentsQuestionsError,
    assessmentsAnswersError,
  ]);

  return {
    retryLoadAssessments,
  };
};
